<input 
    type="checkbox"
    appFormCheckField 
    [id]="id()"
    [name]="name()"
    [checked]="checked()"
    (onChange)="onChangeHandler($event)"
/>